module.exports = __webpack_public_path__ + "img/009-wind-5.891ccc82.svg";